import { render, staticRenderFns } from "./BuyerInfo.vue?vue&type=template&id=8791a832&scoped=true&"
import script from "./BuyerInfo.vue?vue&type=script&lang=js&"
export * from "./BuyerInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInfo.vue?vue&type=style&index=0&id=8791a832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791a832",
  null
  
)

export default component.exports